/* eslint-disable */
import {
  auditOnPlatformDevOrganization,
  foaQaAutomationAuditApiOrganization,
} from '../organizations';
import { getLaunchpadUsers } from './test-user-base-info';

// Environment-specific arrays for seeders
// All new audit users are dev-only per requirement
export const devAuditOnPlatformTestUsers = getLaunchpadUsers([
  // General users
  {
    email: 'agkovacs@diligent.com',
    name: 'Ágnes Kovacs',
    highbondId: 'yCEPozU7jD1KHN617kc7',
    id: 'D0714005-FE69-4CB1-845D-029101AA70D1',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'apinter@diligent.com',
    name: 'Ákos Pintér 55',
    highbondId: 'b65kW1AgzHPgsBCtvgZ7',
    id: '3A27161E-D532-4DC6-AC35-76B6441166B7',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'azamora@diligent.com',
    name: 'Alejandro Zamora',
    highbondId: 'c55Gfc48FTaULoLrqrjG',
    id: 'AAC0D7EE-FC5E-4C41-9D83-31C55D6DCF41',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'palmasi@diligent.com',
    name: 'Almási Patrik',
    highbondId: 'R8RC2JVTeED_fZGWieD6',
    id: 'DDF087D7-58E4-44F5-A9DB-2D8EAAE808EC',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'bbodnar@diligent.com',
    name: 'Balázs Bodnár',
    highbondId: 'zxswyZUFZb6VLxiZt6s4',
    id: '7AC85499-EAE3-49B8-ABD8-903144DEFEB4',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'bbodnar-audit-manager@diligent.com',
    name: 'Balázs Bodnár Audit Manager',
    highbondId: 'wLdVmz58DYmysgCxEZyv',
    id: '33693DA5-495E-4E83-BA42-B8252E21FED5',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'bbodnar-audit-auditor@diligent.com',
    name: 'Balázs Bodnár Audit Auditor',
    highbondId: 'prPzHsP8hCxz4igcM7xR',
    id: '98A5778A-8E76-4158-98F0-EBA2A1ADB3C2',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'bbodnar-head-of-audit@diligent.com',
    name: 'Balázs Bodnár Head Audit',
    highbondId: 'cyGVSwzg9WZsbiP55gUe',
    id: 'BF302720-B983-4175-BE78-6555943F92D0',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'calfonzo@diligent.com',
    name: 'Carlos Alfonzo',
    highbondId: 'RLWj1MMwHDSt51VsMBVX',
    id: '0FD01841-8AC3-4362-9E70-CBCB841FAF25',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'bbodnar-audit-qa@diligent.com',
    name: 'Balázs Bodnár Audit QA',
    highbondId: 'Qyr9faDB335youXs9jyN',
    id: 'D97EC73F-47A2-402C-A052-3EDF736796A9',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'dgallegos@diligent.com',
    name: 'David Gallegos',
    highbondId: '5PBztJY8qf5JQpxgAWkF',
    id: 'D6BB0E45-E0D4-4D20-A2A7-37BE88C1EABF',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'dsaran@diligent.com',
    name: 'Dominik Saran',
    highbondId: '_uD1kj_RR3RX5zHEf5ff',
    id: 'B5889DA4-77E1-4EAB-B49B-98F234587496',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'dkovacs@diligent.com',
    name: 'Dorottya Kovács',
    highbondId: '-VwnhXJxZgZ9ibyZipsz',
    id: '85039A3E-11A3-41E5-B862-A9092BAD21D0',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'ebaruf@diligent.com',
    name: 'Ezequiel Baruf',
    highbondId: 'Qpsx1VUxMeK_ddNsSxKd',
    id: '4AC0B7B0-8A99-4D2F-BF57-C60A2802CA54',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'jbabi@diligent.com',
    name: 'John Babi',
    highbondId: 'Lhz8HjATMhk4Q2w9YHeT',
    id: '30B3D524-8426-4E66-A94F-1F93019E08FD',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'ktakacs@diligent.com',
    name: 'Katalin Takács',
    highbondId: 'oAaMQySdW3Jih3yVW8QD',
    id: 'BEB7E18B-8F9E-4E52-BE8A-B7112FB5C806',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'lbende@diligent.com',
    name: 'László Bende',
    highbondId: 'yy5aJ9-a8dLrxWGmz6CN',
    id: 'B97B3766-73B1-4579-B110-E7A69A57C711',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'malmeida@diligent.com',
    name: 'Matias Almeida',
    highbondId: '6bdPQEzWpKzAktXsaXSp',
    id: '24959AB0-FE38-4E26-A7F1-0D4AC95C6E5B',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'ntoth@diligent.com',
    name: 'Norbert Tóth',
    highbondId: 'CBfyno31Yd24hyyzRo1y',
    id: '76C13B6C-9401-447B-AA66-9803A9C3E040',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'vozsvart@diligent.com',
    name: 'Viktoria Ozsvárt',
    highbondId: 'mcVkToFMZAKr6H-BRL59',
    id: '2DB537D4-4613-44B7-B075-725BDF967517',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'svasudevan@diligent.com',
    name: 'Suchitra Vasudevan',
    highbondId: 'zARnxZym-iqs6zhNKpxV',
    id: 'BF6CD0D9-6573-41A4-BBBA-81B8A58582AC',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'nerdelyi@diligent.com',
    name: 'Noémi Erdélyi',
    highbondId: 'VEwKTLXyBc9Z1xuDxHzU',
    id: 'A06B5831-B374-4B77-BE35-95A8ABF987E5',
    organization: auditOnPlatformDevOrganization,
  },
  {
    email: 'fforianszabo@diligent.com',
    name: 'Ferenc Forián-Szabó',
    highbondId: 'xkoK8sBZsmeuyBw53xMJ',
    id: 'C70CAE4B-6A12-4ADB-8841-D856CBCFAD65',
    organization: auditOnPlatformDevOrganization,
  },

  // FoA QA Automation specific users (assigned to org 767)
  {
    email: 'auditor@diligent.com',
    name: 'Auditor',
    highbondId: 'MU_CUM-Hv_JvBcEyA8nE',
    id: 'AFA91885-439A-4ABF-9E1F-4AA2049F6978',
    organization: foaQaAutomationAuditApiOrganization,
  },
  {
    email: 'audit-manager@diligent.com',
    name: 'Audit Manager',
    highbondId: 'xzQDs5uSpPyPd84sf7DB',
    id: '49D169C0-04FD-4B1F-AA6C-1D768EEC862F',
    organization: foaQaAutomationAuditApiOrganization,
  },
  {
    email: 'audit-qa@diligent.com',
    name: 'Audit QA',
    highbondId: 'x6P3nSws2QWjNWp5jjFh',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB42',
    organization: foaQaAutomationAuditApiOrganization,
  },
  {
    email: 'vanguard-professional-user@test.com',
    name: 'Head of Audit',
    highbondId: 'E_4Hzm3YJbgKoonkgByT',
    id: '3579FD40-0623-45C8-BE60-4C122D28AA46',
    organization: foaQaAutomationAuditApiOrganization,
  },
]);
